import React from 'react';
import { CalendarClockIcon, DumbbellIcon } from 'lucide-react';
import { useAppState } from '../../contexts/AppStateContext';
import { FamilyEvent } from '../../types/family';

/** Termin iz koledarja v delu dneva. Športni termin šteje za šport (na zaupanje), razen če ga član označi »ni bilo«. */
export function EventLine({
  event
}: {
  event: FamilyEvent;
}) {
  const {
    viewer,
    isEventSkipped,
    toggleSkipEvent
  } = useAppState();
  const sport = event.type === 'sport' && event.participantIds.includes(viewer.id);
  const skipped = sport && isEventSkipped(event.id, viewer.id);
  const time = event.end ? `${event.start}–${event.end}` : event.start;
  return <li className="flex items-center gap-3 px-4 py-2" data-id="element-1171" data-mp="3cud9aj6l92y7">
      <span className="grid h-7 w-7 shrink-0 place-items-center rounded-lg bg-info-soft text-info-ink" aria-hidden="true" data-id="element-1172" data-mp="38wfk3gctigut">
        {sport ? <DumbbellIcon className="h-4 w-4" data-id="element-1173" data-mp="33y48p16vjyah" /> : <CalendarClockIcon className="h-4 w-4" data-id="element-1174" data-mp="2ywey1mnkdmmx" />}
      </span>
      <span className="min-w-0 flex-1 text-sm" data-id="element-1175" data-mp="2yz1ds9klz8g8">
        <span className="font-extrabold tabular-nums text-info-ink" data-id="element-1176" data-mp="ezijcsd6l8yb">{time}</span> <span className="font-bold" data-id="element-1177" data-mp="jq8qaa199jv4">{event.title}</span>
        {sport && <span className={`block text-xs font-semibold ${skipped ? 'text-muted line-through' : 'text-done-ink'}`} data-id="element-1178" data-mp="jsleh4xlwqgm">šteje za šport</span>}
      </span>
      {sport && <button type="button" onClick={() => toggleSkipEvent(event.id)} aria-pressed={skipped} className="shrink-0 rounded-full px-2.5 py-1 text-xs font-bold text-muted transition-colors duration-150 hover:bg-canvas hover:text-ink" data-id="element-1179" data-mp="ayov1xvtts4w">
          {skipped ? 'Je bilo' : 'Ni bilo'}
        </button>}
    </li>;
}